import React, {FC} from 'react';
import cn from 'classnames';
import {useLocalizer} from '@/common/services/localizer';
import styles from './ConditionMediumIcon.css';

interface ConditionMediumIconProps {
	className?: string;
	condition: number;
	isNight?: boolean;
}

export const ConditionMediumIcon: FC<ConditionMediumIconProps> = props => {
	const {className, condition, isNight} = props;

	const t = useLocalizer();

	return (
		<div
			className={cn(
				styles.root,
				styles[`condition${condition}`],
				isNight ? styles.periodNight : styles.periodDay,
				className,
			)}
			aria-label={t(`weatherConditions.${condition}`)}
		/>
	);
};

ConditionMediumIcon.displayName = 'ConditionMediumIcon';
